<div class="header-bar">
  <div class="menu-container">
    <button class="hamburger-menu" (click)="onMenuClick()">
      @if (!isMenuOpen) {
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1265_783)">
              <path
                d="M4 6H20"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4 12H20"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4 18H20"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1265_783">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
      }

      @if (isMenuOpen) {
        <span class="close-menu">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 6L18 18M6 18L18 6"
              stroke="#ffffff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      }
    </button>
  </div>
  <div class="logo-container">
    <img src="{{ logoPath }}" alt="Logo" />
  </div>
  <div class="right-section">
    <div class="profile-container">
      <img src="{{ profileImagePath }}" alt="Profile" class="profile-image" />
      <div class="profile-info">
        <span class="user-name">{{ userName }}</span>
        <span class="user-designation">{{ userDesignation }}</span>
      </div>
    </div>
  </div>
</div>
@if (isMenuOpen) {
  <div class="menu">
    <a routerLink="/evaluator-dashboard">
      <svg
        class="menu-icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1006_11624)">
          <path
            d="M3.33366 2.6665H6.00033C6.17714 2.6665 6.34671 2.73674 6.47173 2.86177C6.59675 2.98679 6.66699 3.15636 6.66699 3.33317V7.33317C6.66699 7.50998 6.59675 7.67955 6.47173 7.80457C6.34671 7.9296 6.17714 7.99984 6.00033 7.99984H3.33366C3.15685 7.99984 2.98728 7.9296 2.86225 7.80457C2.73723 7.67955 2.66699 7.50998 2.66699 7.33317V3.33317C2.66699 3.15636 2.73723 2.98679 2.86225 2.86177C2.98728 2.73674 3.15685 2.6665 3.33366 2.6665Z"
            stroke="#030213"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.33366 10.6665H6.00033C6.17714 10.6665 6.34671 10.7367 6.47173 10.8618C6.59675 10.9868 6.66699 11.1564 6.66699 11.3332V12.6665C6.66699 12.8433 6.59675 13.0129 6.47173 13.1379C6.34671 13.2629 6.17714 13.3332 6.00033 13.3332H3.33366C3.15685 13.3332 2.98728 13.2629 2.86225 13.1379C2.73723 13.0129 2.66699 12.8433 2.66699 12.6665V11.3332C2.66699 11.1564 2.73723 10.9868 2.86225 10.8618C2.98728 10.7367 3.15685 10.6665 3.33366 10.6665Z"
            stroke="#030213"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.99967 8H12.6663C12.8432 8 13.0127 8.07024 13.1377 8.19526C13.2628 8.32029 13.333 8.48986 13.333 8.66667V12.6667C13.333 12.8435 13.2628 13.013 13.1377 13.1381C13.0127 13.2631 12.8432 13.3333 12.6663 13.3333H9.99967C9.82286 13.3333 9.65329 13.2631 9.52827 13.1381C9.40325 13.013 9.33301 12.8435 9.33301 12.6667V8.66667C9.33301 8.48986 9.40325 8.32029 9.52827 8.19526C9.65329 8.07024 9.82286 8 9.99967 8Z"
            stroke="#030213"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.99967 2.6665H12.6663C12.8432 2.6665 13.0127 2.73674 13.1377 2.86177C13.2628 2.98679 13.333 3.15636 13.333 3.33317V4.6665C13.333 4.84331 13.2628 5.01288 13.1377 5.13791C13.0127 5.26293 12.8432 5.33317 12.6663 5.33317H9.99967C9.82286 5.33317 9.65329 5.26293 9.52827 5.13791C9.40325 5.01288 9.33301 4.84331 9.33301 4.6665V3.33317C9.33301 3.15636 9.40325 2.98679 9.52827 2.86177C9.65329 2.73674 9.82286 2.6665 9.99967 2.6665Z"
            stroke="#030213"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1006_11624">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Dashboard
    </a>
  </div>
}
